<div class="p-3" style="font-size: 0.9rem">
  <div *ngIf="record.status !== 21">Preplanning was completed by <b>{{ record.preplannedUser_Name ?? 'Unknown User' }}</b> on <b>{{ (record.datePlanningFinished | date: 'MM/dd/yyyy') ?? 'Unknown Date' }}</b></div>
  <div *ngIf="record.status === 21">Preplanning is assigned to <b>UserNameHere</b> has not yet been finished.</div>
</div>